<template>
  <div class="base-info">
    <div class="base-top flex">
      <div class="columns columns-one">
        <div class="row">
          <div class="row-item flex aling-center">
            <div class="item-label">
              项目名称：
            </div>
            <div class="item-value">
              <el-tooltip effect="dark" :content="form.projectName" placement="top">
                <div class="supplier-add">
                  {{ form.projectName }}
                </div>
              </el-tooltip>
            </div>
          </div>
          <div class="row-item flex">
            <div class="item-label">
              订单分类：
            </div>
            <div class="item-value">
              {{ form.orderType }}
            </div>
          </div>
          <div class="row-item flex">
            <div class="item-label">
              供货单位电话(甲方)：
            </div>
            <div class="item-value">
              {{ form.supplyPhone }}
            </div>
          </div>
          <div class="row-item flex">
            <div class="item-label">
              客户签约类型：
            </div>
            <div class="item-value">
              {{ form.customerContractType }}
            </div>
          </div>
          <div class="row-item flex">
            <div class="item-label">
              区域商务专员：
            </div>
            <div class="item-value">
              {{ form.assistantName }}
            </div>
          </div>
          <div class="row-item flex">
            <div class="item-label">
              订单类型：
            </div>
            <div class="item-value">
              {{ formDataDetail.postOrdetypeName }}
            </div>
          </div>
          <div class="row-item flex">
            <div class="item-label">
              销往区域：
            </div>
            <div class="item-value">
              {{ form.salesArea }}
            </div>
          </div>
          <div class="row-item flex">
            <div class="item-label">
              结算方式：
            </div>
            <div class="item-value">
              <!-- 退货的产品 -->
              <template v-if="title.includes('退货合同')">
                <el-radio v-model="form.salesSettlementModes" :label="1" disabled>
                  现销
                </el-radio>
                <el-radio v-model="form.salesSettlementModes" :label="2" disabled>
                  赊销
                </el-radio>
                <el-radio v-model="form.salesSettlementModes" :label="3" disabled>
                  LC
                </el-radio>
              </template>
              <!-- 换货产品 -->
              <template v-if="!title.includes('退货合同')">
                <el-radio v-model="formDataDetail.salesSettlementModes" :label="1" disabled>
                  现销
                </el-radio>
                <el-radio v-model="formDataDetail.salesSettlementModes" :label="2" disabled>
                  赊销
                </el-radio>
                <el-radio v-model="formDataDetail.salesSettlementModes" :label="3" disabled>
                  LC
                </el-radio>
              </template>
            </div>
          </div>
          <div class="row-item flex">
            <div class="item-label">
              远期时间：
            </div>
            <div class="item-value">
              {{ form.sightDate }}
            </div>
          </div>
          <div class="row-item flex">
            <div class="item-label">
              使用返利金额：
            </div>
            <div class="item-value">
              <!-- 退货合同 -->
              <span v-if="title==='退货合同'">{{ formDataDetail.refundRebate }}</span>
              <!-- 换货合同 -->
              <span v-if="title==='换货合同'">{{ formDataDetail.useRebateAmount }}</span>
            </div>
          </div>
          <div class="row-item flex">
            <div class="item-label">
              目的地：
            </div>
            <div class="item-value">
              {{ form.destination }}
            </div>
          </div>
          <div class="row-item flex">
            <div class="item-label">
              业务类型：
            </div>
            <div class="item-value">
              {{ form.projectType }}
            </div>
          </div>
          <div class="row-item flex">
            <div class="item-label">
              原退货单总返利金额：
            </div>
            <div class="item-value">
              {{ form.originallyRebateAmount }}
            </div>
          </div>
        </div>
      </div>
      <div class="columns columns-two">
        <div class="row-item flex">
          <div class="item-label">
            订单日期：
          </div>
          <div class="item-value">
            {{ form.createdTime }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            供货单位(甲方)：
          </div>
          <div class="item-value">
            {{ form.supplyUnit }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            供货单位(乙方)：
          </div>
          <div class="item-value">
            {{ formData.orderUnitName }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            区域：
          </div>
          <div class="item-value">
            {{ form.regionName }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            售前姓名：
          </div>
          <div class="item-value">
            {{ form.preSalesPersonName }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            计量计点：
          </div>
          <div class="item-value">
            <span v-if="form.meteringPoint === 1">计量计点</span>
            <span v-if="form.meteringPoint === 2">计量不计点</span>
            <span v-if="form.meteringPoint === 3">不计量不计点</span>
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            电源线规格(2pin)：
          </div>
          <div class="item-value">
            {{ form.powerCordSpecification }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            账期：
          </div>
          <div class="item-value force-line-break">
            {{ formData.accountPeriod }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            项目代码(CRM编号)：
          </div>
          <div class="item-value">
            {{ form.opportunityCode }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            细分市场：
          </div>
          <div class="item-value">
            {{ form.marketSegmentName }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            齐套通知打款邮箱：
          </div>
          <div class="item-value">
            {{ formDataDetail.setNoticeMail ||'--' }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            是否返现金点：
          </div>
          <div class="item-value">
            {{ form.cashbackPoints ? '是' : '否' }}
          </div>
        </div>
        <div v-if="title !== '罚金合同'" class="row-item flex">
          <div class="item-label">
            {{
              title === '退货合同(已发货)' ? '退货合同(已发货)合同编号：' :
              title === '退货合同(未发货)' ? '退货合同(未发货)合同编号：' :
              '换货合同编号：'
            }}
          </div>
          <div class="item-value">
            {{ form.newContractNum }}
          </div>
        </div>
      </div>
      <div class="columns columns-three">
        <div v-if="title !== '罚金合同'" class="row-item flex">
          <div class="item-label">
            退换货申请单号：
          </div>
          <div class="item-value">
            {{ form.orderNum }}
          </div>
        </div>
        <div v-else class="row-item flex">
          <div class="item-label">
            电子合同编号(申请单号)：
          </div>
          <div class="item-value">
            {{ form.orderNum }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            币种：
          </div>
          <div class="item-value">
            {{ form.currencyName }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            订货单位电话(乙方)：
          </div>
          <div class="item-value">
            {{ formData.orderUnitTel }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            二级渠道名称：
          </div>
          <div class="item-value">
            {{ form.secondChannelName }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            外销姓名：
          </div>
          <div class="item-value">
            {{ form.salesPersonName }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            贸易方式：
          </div>
          <div class="item-value">
            {{ form.tradeTerm }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            电源线规格(3pin)：
          </div>
          <div class="item-value">
            {{ form.threePlugPowerCord }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            净销售额：
          </div>
          <div class="item-value">
            {{ formDataDetail.netSales }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            借条单号：
          </div>
          <div class="item-value">
            {{ form.borrowingOrderNumber }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            应用场合：
          </div>
          <div class="item-value">
            {{ form.applicationScenariosName }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            税率：
          </div>
          <div class="item-value">
            {{ form.formTaxRate }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            现金点比例：
          </div>
          <div class="item-value">
            {{ form.cashPointRatio }}
          </div>
        </div>
        <div v-if="(title !== '罚金合同') && (title.includes('换货合同'))" class="row-item flex">
          <div class="item-label">
            仓库：
          </div>
          <div class="item-value">
            {{ form.warehouse }}
          </div>
        </div>
      </div>
      <div class="columns columns-four">
        <div v-if="title !== '罚金合同'" class="row-item flex">
          <div class="item-label">
            原客户合同编号：
          </div>
          <div class="item-value">
            {{ form.oldContractNum }}
          </div>
        </div>
        <div v-else class="row-item flex">
          <div class="item-label">
            客户合同编号：
          </div>
          <div class="item-value">
            {{ form.oldContractCustomerNum }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            供货单位地址：
          </div>
          <div class="item-value">
            <el-tooltip effect="dark" :content="form.supplyAddress" placement="top">
              <div class="supplier-add">
                {{ form.supplyAddress }}
              </div>
            </el-tooltip>
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            最终客户：
          </div>
          <div class="item-value">
            {{ formData.finalCustomerName }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            二级渠道类型：
          </div>
          <div class="item-value">
            {{ form.secondChannelType }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            部门：
          </div>
          <div class="item-value">
            {{ form.salesPersonDeptName }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            运输方式：
          </div>
          <div class="item-value">
            {{ form.modeOfShipping }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            发货方式：
          </div>
          <div class="item-value">
            <el-radio-group v-model="form.shipType" :disabled="title.includes('退货合同')">
              <el-radio :label="1">
                齐套发货
              </el-radio>
              <el-radio :label="2">
                分批发货
              </el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            即期/远期：
          </div>
          <div class="item-value">
            {{ form.atAfterSight }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            CRM客户编码：
          </div>
          <div class="item-value">
            {{ form.crmAccountCode }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            云桌面授权邮箱：
          </div>
          <div class="item-value">
            {{ form.authorizationEmail }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            采购类型：
          </div>
          <div class="item-value">
            {{ form.purchaseType }}
          </div>
        </div>
        <div class="row-item flex">
          <div class="item-label">
            退换货原因：
          </div>
          <div class="item-value">
            <!-- D8：落库值（如“产品发运错误”）经 displayReasonType 映射后再展示 -->
            {{ displayReasonType(form.reasonType) }}
          </div>
        </div>
      </div>
    </div>
    <div class="base-bottom">
      <div class="row-item flex">
        <div class="item-label">
          补充条款：
        </div>
        <div class="item-value">
          {{ form.supplementalTerm }}
        </div>
      </div>
      <div class="row-item flex">
        <div class="item-label">
          服务条款：
        </div>
        <div class="item-value">
          {{ formDataDetail.serviceTerm }}
        </div>
      </div>
      <div class="row-item flex">
        <div class="item-label">
          收货回执及到货验收要求：
        </div>
        <div class="item-value">
          {{ formDataDetail.specialRemarks }}
        </div>
      </div>
      <div class="row-item flex">
        <div class="item-label">
          备注说明：
        </div>
        <div class="item-value">
          {{ form.remarks }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { displayReasonType } from '@/constant';

export default {
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    formData: {
      type: Object,
      default: () => {}
    },
    formDataDetail: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    };
  },
  components: {},
  methods: {
    // D8：退换货原因展示名映射（落库值保持不变，仅展示层生效）
    displayReasonType
  }
};
</script>
<style lang="scss" scoped>
.base-info{
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  margin-top: 12px;
  .base-top,
  .base-bottom{
    justify-content: space-between;
    .row-item{
      margin-bottom: 26px;
      font-size: 14px;
      color: #505050;
      .supplier-add{
        max-width: 250px;
        overflow: hidden;
        text-overflow: ellipsis;
        text-wrap: nowrap;
      }
      // 必填项样式
      .is-required{
        position: relative;
        &::after{
          content:'*';
          position: absolute;
          left: -10px;
          top: 50%;
          transform: translateY(-50%);
          color: #d43030;
        }
      }
    }
    .is-required-row{
      padding-left: 8px;
    }
    .mb-15{
      margin-bottom: 15px;
    }
    .mb-20{
      margin-bottom: 20px;
    }
  }
  .base-top{
    .columns{
      width: 25%;
    }
  }
  .base-bottom{
    .row-item{
      margin-bottom: 26px;
    }
  }
}
.base-top{
  .item-value{
    ::v-deep .el-select,.el-input{
      width: 270px;
    }
    ::v-deep .el-input--mini .el-input__inner{
      height: 32px;
      line-height: 32px;
      border-color: #e4e4e4;
      color:#505050;
    }
    ::v-deep .el-radio__label{
      padding-left: 5px;
    }
    ::v-deep .el-radio{
      margin-right: 15px;
    }
    ::v-deep .el-radio__input.is-checked .el-radio__inner {
     background: #fff;
    }
    ::v-deep .el-radio__inner::after{
      width: 7px;
      height: 7px;
      background-color: #409EFE;
    }
    ::v-deep .el-radio__input.is-checked + .el-radio__label{
      color: #505050;
    }
  }
}
.base-bottom{
  .row-item{
    .item-value{
      ::v-deep .el-input--mini .el-input__inner{
        border-color: #e4e4e4;
        color:#A6A6A6;
        width: 100%;
      }
    }
  }
}
.flex{
  display: flex;
}
.flex1{
  flex: 1;
}
.aling-center{
  align-items: center;
}

</style>
